import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../../api/login/login.service';
import { PasswordService } from '../../../api/password/password.service';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'cat-top-bar',
    templateUrl: './top-bar.component.html',
})
export class TopBarComponent implements OnInit {
    roleType: string = "";
    userjoinCode: string = "";
    href: string;
    password: string;
    repassword: string;
    message: string;
    constructor(public authService: LoginService, private router: Router,
        public passwordService: PasswordService) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token')) {
            this.roleType = localStorage.getItem('type');
            this.userjoinCode = "Join Code : " + localStorage.getItem('joincode');
        } else {
            this.router.navigate(['../pages/login']);
        }
    }
    onClicked(value: string) {
        var ary = value.split('=');
        this.roleType = ary[1];
        this.userjoinCode = "Join Code : " + ary[2];
    }
    onLogOut() {
        this.authService.logout();
        this.router.navigate(['../pages/login']);
    }
    eventPassword(event) {
        var _event = event || window.event;
        var key = _event.keyCode || _event.which;
        if (48 <= key && key <= 57)
            return true;
        if (65 <= key && key <= 90)
            return true;
        if (97 <= key && key <= 122)
            return true;
        return false;
    }
    uPassword() {
        if (!this.repassword || this.repassword == "") {
            this.message = "Please Enter Password."
            $.notify({
                message: this.message
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            this.password = "";
            this.repassword = "";
        } else if (!this.repassword || this.repassword == "") {
            this.message = "Please Enter Password same as above."
            $.notify({
                message: this.message
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            this.repassword = "";
        } else {
            this.password = this.password.trim();
            this.repassword = this.repassword.trim();
            if (this.password == this.repassword) {
                var upassword = {
                    password: this.password
                }
                this.passwordService
                    .uPassword('change', upassword)
                    .then(data => {
                        if (data.status == true) {
                            this.message = data.message
                            $.notify({
                                message: this.message
                            }, {
                                type: 'success',
                                placement: {
                                    from: 'bottom',
                                    align: 'right'
                                },
                                delay: 100,
                                timer: 100
                            });
                            this.cancelAction();
                            $(function () {
                                $('#passwordModel').modal('toggle');
                            });
                        } else {
                            this.message = data.message
                            $.notify({
                                message: this.message
                            }, {
                                type: 'danger',
                                placement: {
                                    from: 'bottom',
                                    align: 'right'
                                },
                                delay: 100,
                                timer: 100
                            });
                            this.cancelAction();
                        }
                    })
            } else {
                this.message = "Password is not match."
                $.notify({
                    message: this.message
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
                this.repassword = "";
            }
        }
    }
    cancelAction() {
        this.password = "";
        this.repassword = "";
    }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/components/top-bar/top-bar.component.ts